import React from 'react';
import { MapPin, Phone, Mail, Instagram, ArrowUp } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8 border-t border-gray-800" data-id="element-107">
      <div className="container mx-auto px-4 md:px-6" data-id="element-108">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-109">
          {/* Brand */}
          <div data-id="element-110">
            <div className="flex items-center gap-2 mb-6" data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/m833YbxveJrgayp441DGvm/NETCG.png" alt="Logo" className="h-10 w-auto object-contain" data-id="element-112" />
              <span className="font-bold text-xl" data-id="element-113">NETCG & ASOCIADOS</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-114">
              Expertos en movilidad internacional, extranjería y asesoría
              integral para empresas y particulares.
            </p>
            <div className="flex gap-4" data-id="element-115">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-116">
                <Instagram className="w-5 h-5" data-id="element-117" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-118">
            <h3 className="font-bold text-lg mb-6" data-id="element-119">Contacto</h3>
            <ul className="space-y-4" data-id="element-120">
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-121">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0" data-id="element-122" />
                <span data-id="element-123">
                  C. San Vicente 38,
                  <br data-id="element-124" />
                  Getafe, 28901 Madrid
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-125">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" data-id="element-126" />
                <a href="tel:+34618940149" className="hover:text-white transition-colors" data-id="element-127">
                  +34 618 940 149
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-128">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" data-id="element-129" />
                <a href="mailto:info@netcgsolutions.com" className="hover:text-white transition-colors" data-id="element-130">
                  info@netcgsolutions.com
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-131">
            <h3 className="font-bold text-lg mb-6" data-id="element-132">Servicios</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-133">
              <li data-id="element-134">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-135">
                  Movilidad Internacional
                </a>
              </li>
              <li data-id="element-136">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-137">
                  Visados y Permisos
                </a>
              </li>
              <li data-id="element-138">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-139">
                  Contabilidad y Fiscalidad
                </a>
              </li>
              <li data-id="element-140">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-141">
                  Asesoría Mercantil
                </a>
              </li>
              <li data-id="element-142">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-143">
                  Asesoría Laboral
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-144">
            <h3 className="font-bold text-lg mb-6" data-id="element-145">Legal</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-146">
              <li data-id="element-147">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-148">
                  Política de Privacidad
                </a>
              </li>
              <li data-id="element-149">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-150">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-151">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-152">
                  Aviso Legal
                </a>
              </li>
              <li data-id="element-153">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-154">
                  Política de Cookies
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-155">
          <p className="text-gray-500 text-xs text-center md:text-left" data-id="element-156">
            © {new Date().getFullYear()} NETCG & ASOCIADOS. Todos los derechos
            reservados.
          </p>
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="flex items-center gap-2 text-xs text-gray-400 hover:text-white transition-colors" data-id="element-157">
            Volver arriba <ArrowUp className="w-3 h-3" data-id="element-158" />
          </button>
        </div>
      </div>
    </footer>;
}